import BlacklistForm from "./BlacklistForm";

export default BlacklistForm;